<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible">

        <el-form :model="obj" ref="addEditForm" status-icon :rules="rules"> <!--:rules="rules"-->
            <el-tabs v-model="activeName">
                <!-- General -->
                <el-tab-pane label="Personalia" name="general">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="6">
                                <el-form-item prop="gender">
                                    <el-select v-model="obj.enrollment.gender" placeholder="Geslacht" class="w-full">
                            <span slot="prefix">
                                <div v-if="obj.enrollment.gender">
                                    <i class="el-icon-male pl-1"></i>
                                </div>
                                <div v-else>
                                    <i class="el-icon-female pl-1"></i>
                                </div>
                            </span>
                                        <el-option
                                                v-for="item in genderOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item prop="enrollment.firstName">
                                    <el-input placeholder="Voornaam" v-model="obj.enrollment.firstName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="enrollment.lastName">
                                    <el-input placeholder="Achternaam" v-model="obj.enrollment.lastName"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item prop="enrollment.email">
                                <el-input placeholder="Email" v-model="obj.enrollment.email" type="email" :disabled="true"
                                          prefix-icon="el-icon-message"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="enrollment.cellPhone">
                                <el-input placeholder="Telefoon" v-model="obj.enrollment.cellPhone"
                                          prefix-icon="el-icon-mobile-phone"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item prop="enrollment.birthDate">
                                    <el-date-picker
                                            v-model="obj.enrollment.birthDate"
                                            type="date"
                                            class="w-full"
                                            placeholder="Geboortedatum">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="enrollment.nationality">
                                    <el-input placeholder="Nationaliteit" v-model="obj.enrollment.nationality"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :span="8">
                                <el-form-item prop="enrollment.street">
                                    <el-input placeholder="Straat" v-model="obj.enrollment.street"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item prop="enrollment.number">
                                    <el-input placeholder="Nummer" v-model="obj.enrollment.number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-form-item prop="enrollment.postal">
                                    <el-input placeholder="Postcode" v-model="obj.enrollment.postal"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item prop="enrollment.city">
                                    <el-input placeholder="Stad" v-model="obj.enrollment.city"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item prop="enrollment.country">
                                    <el-select v-model="obj.enrollment.country"
                                               placeholder="Land"
                                               class="w-full">
                                         <span slot="prefix">
                                            <i class="el-icon-location-outline pl-1"></i>
                                        </span>
                                        <el-option
                                                v-for="item in countryOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="branchIds">
                                    <el-select v-model="obj.branchIds"
                                               placeholder="Tak"
                                               class="w-full"
                                               multiple
                                               collapse-tags>
                                        <span slot="prefix">
                                            <i class="el-icon-medal pl-1"></i>
                                        </span>
                                        <el-option
                                                v-for="item in branchOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

                <!-- Emergencies -->
                <el-tab-pane label="Noodgevallen" name="emergencies">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item prop="enrollment.emgFirstName">
                                    <el-input placeholder="Voornaam" v-model="obj.enrollment.emgFirstName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="enrollment.emgLastName">
                                    <el-input placeholder="Achternaam" v-model="obj.enrollment.emgLastName"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="enrollment.emgCellPhone">
                                    <el-input placeholder="Telefoon" v-model="obj.enrollment.emgCellPhone"
                                          prefix-icon="el-icon-mobile-phone"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

                <!-- Other -->
                <el-tab-pane label="Andere" name="others">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item prop="enrollment.accountNumber">
                                    <el-input placeholder="Rekeningnummer" v-model="obj.enrollment.accountNumber"
                                          prefix-icon="el-icon-bank-card"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="enrollment.socialSecurityNumber">
                                    <el-input placeholder="Rijksregisternummer" v-model="obj.enrollment.nationalInsuranceNumber"
                                          prefix-icon="el-icon-user"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="enrollment.formations">
                                    <el-input type="textarea"
                                          v-model="obj.enrollment.formations"
                                          placeholder="Opleidingen en vormingen"
                                          maxlength="60"
                                          show-word-limit></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="annotations">
                                    <el-input type="textarea"
                                          v-model="obj.enrollment.annotations"
                                          placeholder="Opmerkingen"
                                          maxlength="60"
                                          show-word-limit></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="Rollen" name="Roles">
                    <div class="flex justify-center">
                        <el-transfer class="self-center"
                                :titles="['Beschikbaar', 'Toegekend']"
                                v-model="obj.roles"
                                :data="roleOptions">
                            <el-popover
                                    slot="left-footer"
                                    placement="top"
                                    width="500"
                                    trigger="hover">
                                <el-table :data="roleInfo">
                                    <el-table-column width="140" property="name" label="Rol">
                                        <template slot-scope="scope">
                                            <el-tag size="small">{{ scope.row.name }}</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column property="description" label="Beschrijving">
                                        <template slot-scope="scope">
                                            <p class="break-normal">{{ scope.row.description }}</p>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <p class="pt-3 px-1">
                                    <strong>Opgelet!</strong> De rollen zijn steeds beperkt tot de takken waaraan de gebruiker is toegekend.
                                </p>
                                <el-button slot="reference" size="mini" class="ml-2">Legende</el-button>
                            </el-popover>
                        </el-transfer>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "UserDialog",
        itemName: "Gebruiker",
        props: ['branchOptions'],
        data() {
            return {
                dialogTitle: "",
                itemName: "Gebruiker",
                dialogVisible: false,
                adding: false,
                activeName: "general",
                obj: this.getEmptyObject(),
                loading: false,

                // Options
                genderOptions: [
                    {
                        value: true,
                        label: "Man"
                    }, {
                        value: false,
                        label: "Vrouw"
                    }
                ],
                roleOptions: [
                    {
                        key: "MEMBER",
                        label: "Lid",
                        disabled: true
                    }, {
                        key: "STAFF",
                        label: "Medewerker"
                    }, {
                        key: "REPRESENTATIVE",
                        label: "Verantwoordelijke"
                    },
                    {
                        key: "SUPPORT_ADMIN",
                        label: "Ondersteuning"
                    },
                    {
                        key: "TREASURER",
                        label: "Schatbewaarder"
                    }, {
                        key: "ADMIN",
                        label: "Admin"
                    }
                ],
                countryOptions: [
                    {
                        value: 0,
                        label: "België"
                    },
                    {
                        value: 1,
                        label: "Nederland"
                    }
                ],

                // Role info
                roleInfo: [{
                    name: 'Lid',
                    description: 'Inloggen op de website en toegang tot privé nieuwsberichten en evenementen.',
                }, {
                    name: 'Medewerker',
                    description: 'Verleent toegang to de prestatie-module, beperkt tot het ingeven van nieuwe prestaties.'
                }, {
                    name: 'Verantwoordelijke',
                    description: 'Verleent toegang tot het admin-paneel, beperkt tot de evenementen, nieuwbserichten, afbeeldingen en vragen modules.'
                },
                {
                    name: 'Ondersteuning',
                    description: 'Verantwoordelijk voor het verwerken van de contacteer-ons berichten.'
                },
                {
                    name: 'Schatbewaarder',
                    description: 'Verleent toegang tot de prestatie- en inschrijvings-modules. Permissie om betalings-status van inschrijvingen te wijzigen.'
                }, {
                    name: 'Admin',
                    description: 'Toegang tot de gebruikers-module.'
                }],

                // Rules
                rules: {
                    enrollment: {
                        firstName: [
                            {required: true, message: 'Vul een naam in.', trigger: 'blur'}
                        ],
                        lastName: [
                            {required: true, message: 'Vul een achternaam in.', trigger: 'blur'}
                        ],
                        email: [
                            {type: 'email', required: true, message: 'Vul een geldig email adres in.', trigger: 'blur'}
                        ],
                        cellPhone: [
                            {required: true, message: 'Vul een telefoonnummer in.', trigger: 'blur'}
                        ],
                        gender: [
                            {required: true, message: 'Selecteer een geslacht.', trigger: 'blur'}
                        ],
                        birthDate: [
                            {required: true, message: 'Selecteer een geboortedatum.', trigger: 'blur'}
                        ],
                        street: [
                            {required: true, message: 'Vul een straat in.', trigger: 'blur'}
                        ],
                        number: [
                            {required: true, message: 'Vul nummer in.', trigger: 'blur'}
                        ],
                        city: [
                            {required: true, message: 'Vul een stad in.', trigger: 'blur'}
                        ],
                        postal: [
                            {required: true, message: 'Vul postcode in.', trigger: 'blur'}
                        ],
                        nationality: [
                            {required: true, message: 'Vul een nationaliteit in.', trigger: 'blur'}
                        ],
                        country: [
                            {required: true, message: 'Selecteer een land.', trigger: 'blur'}
                        ],
                        emgFirstName: [
                            {required: true, message: 'Vul naam contactpersoon in.', trigger: 'blur'}
                        ],
                        emgLastName: [
                            {required: true, message: 'Vul achternaam contactpersoon in.', trigger: 'blur'}
                        ],
                        emgCellPhone: [
                            {required: true, message: 'Vul telefoonnummer contactpersoon in.', trigger: 'blur'}
                        ],
                    },

                    branchIds: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                }
            };
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj))
                this.activeName = "general";
                this.reset()
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.activeName = "general";
                this.reset()
            },
            reset() {
                if(this.$refs['addEditForm']) {
                    this.$refs['addEditForm'].resetFields()
                }
            },
            getEmptyObject() {
                return {
                    enrollment: {
                        // Form data
                        firstName: "",
                        lastName: "",
                        roles: "",
                        email: "",
                        cellPhone: "",
                        gender: null,
                        birthDate: "",
                        street: "",
                        number: "",
                        city: "",
                        postal: "",
                        region: "",
                        country: "",
                        nationality: "",
                        emgFirstName: "",
                        emgLastName: "",
                        emgCellPhone: "",
                        nationalInsuranceNumber: "",
                        accountNumber: "",
                        formations: "",
                        annotations: "",
                    },
                    username: "",
                    branchIds: "",
                    roles: ""
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if(this.adding) {
                            // Username is email
                            this.obj.username = this.obj.enrollment.email
                            this.$parent.objAdded(this.obj);
                        } else {
                            this.$parent.objEdited(this.obj);
                        }
                    } else {
                        this.openAlert('Gelieve alle informatie correct in te vullen.', 'error');
                        return false;
                    }
                });
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            openAlert(msg, type) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: type
                });
                return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dashboard/users/dialogs/UserDialog.vue